const config = {
  name: "ohsu-vip",
  features: {
    accessCodes: false,
    moreInformation: true,
    hasParkingInstructions: true,
    hasPromoCodeWarning: false,
    displayPromoTotalUses: true, // Display "Redemptions left" on promo code card
    mandatoryFields: false,
    userPhoneNumber: true,
    userName: true,
    showAdaSupport: false,
    userPostalCode: false
  },
  parkingSession: {
    // The same day, just before 8am
    cancelDaysBefore: 0,
    cancelTime: "08:00",
    cancelTimeOptions: [],
    // Start time offset from midnight, i.e. 8 am
    startOffsetHrs: 8,
    // Start date offset from today (0 = today)
    startOffsetDate: 0,
    // End date offset from start time
    endOffsetDate: 365
  }
}
export default config
